export default {
  Vultr: [
    {
      name: "Frankfurt",
      url: "https://fra-de-ping.vultr.com/",
      download: "https://fra-de-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Amsterdam",
      url: "https://ams-nl-ping.vultr.com/",
      download: "https://ams-nl-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Paris",
      url: "https://par-fr-ping.vultr.com/",
      download: "https://par-fr-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "London",
      url: "https://lon-gb-ping.vultr.com/",
      download: "https://lon-gb-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Singapore",
      url: "https://sgp-ping.vultr.com/",
      download: "https://sgp-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Tokyo",
      url: "https://hnd-jp-ping.vultr.com/",
      download: "https://hnd-jp-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "New Jersey",
      url: "https://nj-us-ping.vultr.com/",
      download: "https://nj-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Chicago",
      url: "https://il-us-ping.vultr.com/",
      download: "https://il-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Seattle",
      url: "https://wa-us-ping.vultr.com/",
      download: "https://wa-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Atlanta",
      url: "https://ga-us-ping.vultr.com/",
      download: "https://ga-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Miami",
      url: "https://fl-us-ping.vultr.com/",
      download: "https://fl-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Dallas",
      url: "https://tx-us-ping.vultr.com/",
      download: "https://tx-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Silicon Valley",
      url: "https://sjo-ca-us-ping.vultr.com/",
      download: "https://sjo-ca-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Los Angeles",
      url: "https://lax-ca-us-ping.vultr.com/",
      download: "https://lax-ca-us-ping.vultr.com/vultr.com.100MB.bin"
    },
    {
      name: "Sydney",
      url: "https://syd-au-ping.vultr.com/",
      download: "https://syd-au-ping.vultr.com/vultr.com.100MB.bin"
    }
  ]
  // Linode: [
  //   {
  //     name: "Newark",
  //     url: "http://speedtest.newark.linode.com/",
  //     download: "http://speedtest.newark.linode.com/100MB-newark.bin"
  //   },
  //   {
  //     name: "Atlanta",
  //     url: "http://speedtest.atlanta.linode.com/",
  //     download: "http://speedtest.atlanta.linode.com/100MB-atlanta.bin"
  //   },
  //   {
  //     name: "Dallas",
  //     url: "http://speedtest.dallas.linode.com/",
  //     download: "http://speedtest.dallas.linode.com/100MB-dallas.bin"
  //   },
  //   {
  //     name: "Fremont",
  //     url: "http://speedtest.fremont.linode.com/",
  //     download: "http://speedtest.fremont.linode.com/100MB-fremont.bin"
  //   },
  //   {
  //     name: "Frankfurt",
  //     url: "http://speedtest.frankfurt.linode.com/",
  //     download: "http://speedtest.frankfurt.linode.com/100MB-frankfurt.bin"
  //   },
  //   {
  //     name: "London",
  //     url: "http://speedtest.london.linode.com/",
  //     download: "http://speedtest.london.linode.com/100MB-london.bin"
  //   },
  //   {
  //     name: "Singapore",
  //     url: "http://speedtest.singapore.linode.com/",
  //     download: "http://speedtest.singapore.linode.com/100MB-singapore.bin"
  //   },
  //   {
  //     name: "Tokyo 2",
  //     url: "http://speedtest.tokyo2.linode.com/",
  //     download: "http://speedtest.tokyo2.linode.com/100MB-tokyo2.bin"
  //   }
  // ],
  // DigitalOcean: [
  //   {
  //     name: "NYC1",
  //     url: "http://speedtest-nyc1.digitalocean.com/",
  //     download: "http://speedtest-nyc1.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "NYC2",
  //     url: "http://speedtest-nyc2.digitalocean.com/",
  //     download: "http://speedtest-nyc2.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "NYC3",
  //     url: "http://speedtest-nyc3.digitalocean.com/",
  //     download: "http://speedtest-nyc3.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "AMS2",
  //     url: "http://speedtest-ams2.digitalocean.com/",
  //     download: "http://speedtest-ams2.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "AMS3",
  //     url: "http://speedtest-ams3.digitalocean.com/",
  //     download: "http://speedtest-ams3.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "SFO1",
  //     url: "http://speedtest-sfo1.digitalocean.com/",
  //     download: "http://speedtest-sfo1.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "SFO2",
  //     url: "http://speedtest-sfo2.digitalocean.com/",
  //     download: "http://speedtest-sfo2.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "SGP1",
  //     url: "http://speedtest-sgp1.digitalocean.com/",
  //     download: "http://speedtest-sgp1.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "LON1",
  //     url: "http://speedtest-lon1.digitalocean.com/",
  //     download: "http://speedtest-lon1.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "FRA1",
  //     url: "http://speedtest-fra1.digitalocean.com/",
  //     download: "http://speedtest-fra1.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "TOR1",
  //     url: "http://speedtest-tor1.digitalocean.com/",
  //     download: "http://speedtest-tor1.digitalocean.com/100mb.test"
  //   },
  //   {
  //     name: "BLR1",
  //     url: "http://speedtest-blr1.digitalocean.com/",
  //     download: "http://speedtest-blr1.digitalocean.com/100mb.test"
  //   }
  // ],
  // VirMach: [
  //   {
  //     name: "Frankfurt",
  //     url: "http://ffm.lg.virmach.com/",
  //     download: "http://ffm.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Amsterdam",
  //     url: "http://ams.lg.virmach.com/",
  //     download: "http://ams.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Buffalo",
  //     url: "http://ny.lg.virmach.com/",
  //     download: "http://ny.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Piscataway (NYC)",
  //     url: "http://nj.lg.virmach.com/",
  //     download: "http://nj.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Dallas",
  //     url: "http://dal.lg.virmach.com/",
  //     download: "http://dal.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Phoenix",
  //     url: "http://phx.lg.virmach.com/",
  //     download: "http://phx.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Los Angeles",
  //     url: "http://la.lg.virmach.com/",
  //     download: "http://la.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "DDoS-Protected Los Angeles",
  //     url: "http://filtered-la.lg.virmach.com/",
  //     download: "http://filtered-la.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Chicago",
  //     url: "http://chi.lg.virmach.com/",
  //     download: "http://chi.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Seattle",
  //     url: "http://sea.lg.virmach.com/",
  //     download: "http://sea.lg.virmach.com/100MB.test"
  //   },
  //   {
  //     name: "Atlanta",
  //     url: "http://atl.lg.virmach.com/",
  //     download: "http://atl.lg.virmach.com/100MB.test"
  //   }
  // ],
  // //
  // // Official test URLs of BandwagonHost
  // // (BandwagonHost does not publicly provide test URLs)
  // // (These are obtained by directly asking BandwagonHost)
  // BandwagonHost: [
  //   {
  //     name: "Los Angeles DC9 CN2 GIA KVM",
  //     url: "http://65.49.131.102/"
  //   },
  //   {
  //     name: "Los Angeles DC3 CN2 KVM",
  //     url: "http://23.252.103.101/"
  //   },
  //   {
  //     name: "Los Angeles DC8 CN2 KVM",
  //     url: "http://23.252.99.102/"
  //   },
  //   {
  //     name: "Los Angeles DC2 QNET KVM",
  //     url: "http://23.252.96.201/",
  //     download: "http://23.252.96.201/100mb.bin"
  //   },
  //   {
  //     name: "Los Angeles DC2 QNET OpenVZ",
  //     url: "http://104.194.76.20/",
  //     download: "http://104.194.76.20/100mb.bin"
  //   },
  //   {
  //     name: "Los Angeles DC4 MCOM",
  //     url: "http://98.142.136.11/",
  //     download: "http://98.142.136.11/100mb.bin"
  //   },
  //   {
  //     name: "Fremont",
  //     url: "http://184.105.138.80/",
  //     download: "http://184.105.138.80/100mb.bin"
  //   },
  //   {
  //     name: "New York",
  //     url: "http://208.167.227.122/",
  //     download: "http://208.167.227.122/100mb.bin"
  //   },
  //   {
  //     name: "New Jersey",
  //     url: "http://23.29.138.5/",
  //     download: "http://23.29.138.5/100mb.bin"
  //   },
  //   {
  //     name: "Netherlands",
  //     url: "http://45.62.120.202/",
  //     download: "http://45.62.120.202/100mb.bin"
  //   },
  //   {
  //     name: "Vancouver",
  //     url: "http://172.93.32.16/",
  //     download: "http://172.93.32.16/100mb.bin"
  //   }
  // ],
  // //
  // // Source: https://www.ramnode.com/
  // RamNode: [
  //   {
  //     name: "New York City",
  //     url: "http://lg.nyc.ramnode.com/",
  //     download: "http://lg.nyc.ramnode.com/static/100MB.test"
  //   },
  //   {
  //     name: "Atlanta",
  //     url: "http://lg.atl.ramnode.com/",
  //     download: "http://lg.atl.ramnode.com/static/100MB.test"
  //   },
  //   {
  //     name: "Seattle",
  //     url: "http://lg.sea.ramnode.com/",
  //     download: "http://lg.sea.ramnode.com/static/100MB.test"
  //   },
  //   {
  //     name: "Los Angeles",
  //     url: "http://lg.la.ramnode.com/",
  //     download: "http://lg.la.ramnode.com/static/100MB.test"
  //   },
  //   {
  //     name: "Netherlands",
  //     url: "http://lg.nl.ramnode.com/",
  //     download: "http://lg.nl.ramnode.com/static/100MB.test"
  //   }
  // ],
  // //
  // // Source: https://www.host1plus.com/data-centers/
  // Host1Plus: [
  //   {
  //     name: "Los Angeles",
  //     url: "http://191.101.236.61/",
  //     download: "http://191.101.236.61/100mb"
  //   },
  //   {
  //     name: "Chicago",
  //     url: "http://181.214.61.207/",
  //     download: "http://181.214.61.207/100mb"
  //   },
  //   {
  //     name: "São Paulo",
  //     url: "http://191.96.4.248/",
  //     download: "http://191.96.4.248/100mb"
  //   },
  //   {
  //     name: "Frankfurt",
  //     url: "http://185.137.13.237/",
  //     download: "http://185.137.13.237/100mb"
  //   },
  //   {
  //     name: "Johannesburg",
  //     url: "http://196.251.248.78/",
  //     download: "http://196.251.248.78/100mb"
  //   }
  // ]
};
